import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { CloseButton, TextField, Typography } from 'seagull';
import { isUrlValid } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVIdeoModal.utils';
import VideoPlayer, { isStatusSuccess, VideoPlayerStatus } from '~/components/VideoPlayer/VideoPlayer';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './IntoVideoModal.module.scss';
const IntroVideoModalContent = (param)=>{
    let { form, setInputVideoName, setVideoPlayableStatus, videoPlayableStatus } = param;
    const { t: texts } = useLocaleKeys('components.agreementStudio.introVideo');
    const handleReady = ()=>{
        form.clearErrors();
        setVideoPlayableStatus(VideoPlayerStatus.SUCCESS);
    };
    const handleError = (status)=>{
        setVideoPlayableStatus(status);
    };
    const onReady = (param)=>{
        let { videoName } = param;
        handleReady();
        setInputVideoName(videoName);
    };
    const validateVideoLinkField = (videoLinkToValidate)=>{
        if (!isUrlValid(videoLinkToValidate)) {
            setInputVideoName('');
            return 'URL is invalid';
        }
        switch(videoPlayableStatus){
            case VideoPlayerStatus.NOT_FOUND:
                {
                    setInputVideoName('');
                    return 'Video was not found';
                }
            case VideoPlayerStatus.ACCESS_DENIED:
                {
                    setInputVideoName('');
                    return "Unable to access the video. Please check the video's privacy settings.";
                }
            case VideoPlayerStatus.SUCCESS:
            default:
                return;
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentContainer,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: texts.pasteUrl()
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: form.control,
                name: "videoLink",
                rules: {
                    validate: (value)=>validateVideoLinkField(value)
                },
                render: (p)=>/*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(TextField, _object_spread({
                                collapseHelperText: false,
                                testId: "intro-video-modal-url-field",
                                placeholder: texts.videoUrlPlaceholder(),
                                autoFocus: true,
                                suffix: /*#__PURE__*/ _jsx(CloseButton, {
                                    testId: "intro-video-modal-remove-video-name-button",
                                    skin: "transparent",
                                    onClick: ()=>{
                                        setInputVideoName('');
                                        form.setValue('videoLink', '');
                                    }
                                })
                            }, connectControllerToTextField(p))),
                            isUrlValid(p.field.value) && /*#__PURE__*/ _jsx("div", {
                                "data-testid": "intro-video-modal-video-player",
                                style: {
                                    display: isStatusSuccess(videoPlayableStatus) ? 'inherit' : 'none',
                                    minHeight: 300
                                },
                                children: /*#__PURE__*/ _jsx(VideoPlayer, {
                                    url: p.field.value,
                                    onError: handleError,
                                    onReady: onReady
                                })
                            })
                        ]
                    })
            })
        ]
    });
};
export default IntroVideoModalContent;
